import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/homeData";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleLink = (href: string) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 z-50 w-full transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/90 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a
          href="#home"
          onClick={(e) => {
            e.preventDefault();
            handleLink("#home");
          }}
          className="flex items-center gap-2 whitespace-nowrap"
          aria-label="奇妙漫画网首页"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-palette-line text-lg" />
          </span>
          <span className="font-heading text-xl text-foreground-950">
            奇妙漫画网
          </span>
        </a>

        <ul className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleLink(link.href);
                }}
                className="whitespace-nowrap rounded-full px-3 py-2 text-sm font-medium text-foreground-800 transition-colors hover:bg-primary-100 hover:text-primary-700"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href="#latest"
            onClick={(e) => {
              e.preventDefault();
              handleLink("#latest");
            }}
            className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            开始阅读
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-100 text-foreground-900 lg:hidden"
          aria-label="打开菜单"
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          <ul className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleLink(link.href);
                  }}
                  className="block rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-900 hover:bg-primary-100"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#latest"
            onClick={(e) => {
              e.preventDefault();
              handleLink("#latest");
              setOpen(false);
            }}
            className="mt-3 block whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-center text-sm font-bold text-background-50"
          >
            开始阅读
          </a>
        </div>
      )}
    </header>
  );
}